import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-no-permissions',
  templateUrl: './no-permissions.component.html',
  encapsulation: ViewEncapsulation.None
})
export class NoPermissionsComponent {}
